import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { isArray, isString } from "../../Utils/Utils";
export var OptionsColor = /*#__PURE__*/function () {
  function OptionsColor() {
    _classCallCheck(this, OptionsColor);

    this.value = "";
  }

  _createClass(OptionsColor, [{
    key: "load",
    value: function load(data) {
      if ((data === null || data === void 0 ? void 0 : data.value) === undefined) {
        return;
      }

      this.value = data.value;
    }
  }], [{
    key: "create",
    value: function create(source, data) {
      var color = new OptionsColor();
      color.load(source);

      if (data !== undefined) {
        if (isString(data) || isArray(data)) {
          color.load({
            value: data
          });
        } else {
          color.load(data);
        }
      }

      return color;
    }
  }]);

  return OptionsColor;
}();